export type ValueXpr = { $type: "val"; value: any };

export const valExpr = <T>(v: T): ValueXpr => ({
  $type: "val",
  value: v,
});
